'use strict';

/**
 * @ngdoc service
 * @name vTvPackageServices.TvPackageListService
 * @description Manages the packages list returned by the api
 */

angular.module('v-tv-package-services').service('TvPackageListService', function TvPackageListService(TvPackageApi, tvPackageConfig) {

  /**
   * @ngdoc method
   * @name vTvPackageServices.TvPackageListService#getPackages
   * @methodOf vTvPackageServices.TvPackageListService
   * @description Gets the list of available packages from the api
   * @returns {Promise} A promise that completes after receiving the list of available packages from the API
   */

  this.getPackages = function () {
    return TvPackageApi.doGet(tvPackageConfig.ENDPOINT.PACKAGES_LIST).then(function (response) {
      return response.data;
    });
  };
});